import React, { useState, useEffect } from 'react';
import DataResource from './../../../common/v4/DataResource'
import Panel from './../../../common/layout/Panel'
import VoiceCdrDetails from './cdrdetails'


const MoneyComponent = (value) => {
    return (
        <div>
            {value.toFixed(4)}
        </div>
    )
}

export default class extends React.Component {
    render () {
        const today = new Date();
        const data = {
            url: '/admin/reports/voice/cdr/billing-records',
            limit: 50,
            offset: 0,
            filter: {},
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: false,
            filterColumnWidth: 4,
            userFilterExpandable: true,
            userFilterSimple: true,
            userfilter:
            [
                {
                    source: 'start_time',
                    label: 'Date',
                    type: 'date_range',
                    default: {
                        'from' : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                        'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                    }
                },
                {
                    source: 'source_number',
                    label: 'Source Number',
                    type: 'text',
                    default: ''
                },
                {
                    source: 'destination_number',
                    label: 'Destination Number',
                    type: 'text',
                    default: ''
                },
                {
                    source: 'originating_carrier_id',
                    label: 'Client (Egress)',
                    type: 'select',
                    default: ''
                },
                {
                    source: 'terminating_carrier_id',
                    label: 'Termination Carrier (Ingress)',
                    type: 'select',
                    default: ''
                },
                {
                    source: 'sell_description',
                    label: 'Destination Name',
                    type: 'text',
                    default: ''
                },
                {
                    source: 'sell_cost_currency',
                    label: 'Currency',
                    type: 'select',
                    default: ''
                }
            ],
            onclick: 'view',
            view: {
                label: 'View',
                url: '/admin/reports/voice/cdr/log/',
                type: 'drawer',
                component: <VoiceCdrDetails />,
                title: 'Voce CDR Details',
            },
            metadata:
                [
                    {
                        label: 'id',
                        source: 'id',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Start Time',
                        source: 'start_time',
                        type: 'datetime',
                    },
                    {
                        label: 'Client (Egress)',
                        source: 'originating_carrier_name',
                        type: 'text'
                    },
                    {
                        label: 'Client Account',
                        source: 'originating_carrier_account_name',
                        type: 'text'
                    },
                    {
                        label: 'Call Source RegID',
                        source: 'call_source_regid',
                        type: 'text'
                    },
                    {
                        label: 'Call Source UPort',
                        source: 'call_source_uport',
                        type: 'text'
                    },
                    {
                        label: 'Termination Carrier (Ingress)',
                        source: 'terminating_carrier_name',
                        type: 'text'
                    },
                    {
                        label: 'Call Dest RegID',
                        source: 'call_dest_regid',
                        type: 'text'
                    },
                    {
                        label: 'Call Dest UPort',
                        source: 'call_dest_uport',
                        type: 'text'
                    },
                    
                    {
                        label: 'Source Number',
                        source: 'source_number',
                        type: 'text'
                    },
                    {
                        label: 'Destination Number',
                        source: 'destination_number',
                        type: 'text'
                    },  
                    {
                        label: 'Billed Destination Number',
                        source: 'billed_destination_number',
                        type: 'text'
                    }, 
                    {
                        label: 'Duration',
                        source: 'duration',
                        type: 'time'
                    },
                    {
                        label: 'Sell Cost',
                        source: 'sell_cost',
                        type: 'component',
                        component: MoneyComponent
                    },
                    {
                        label: 'Currency',
                        source: 'sell_cost_currency',
                        type: 'text'
                    },
                    {
                        label: 'Buy Cost',
                        source: 'buy_cost',
                        type: 'component',
                        component: MoneyComponent
                    },
                    {
                        label: 'Buy Currency',
                        source: 'buy_cost_currency',
                        type: 'text'
                    }
                ]
        }
        return (
            <Panel title = "Voice CDR Log">
                <DataResource
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}